export type CoeWatchlistPrintFilters = {
  tab?: 'all' | 'coeSoon' | 'overdue';
  vesselId?: string;
  withinDays?: string;
  search?: string;
};

export function coeWatchlistPrintPath(filters: CoeWatchlistPrintFilters = {}): string {
  const qs = new URLSearchParams();
  qs.set('withinDays', filters.withinDays?.trim() || '90');
  if (filters.vesselId?.trim()) qs.set('vesselId', filters.vesselId.trim());
  if (filters.tab && filters.tab !== 'all') qs.set('tab', filters.tab);
  if (filters.search?.trim()) qs.set('q', filters.search.trim());
  return `/crew/coe-watchlist/print?${qs.toString()}`;
}

export function coeWatchlistListApiUrl(params: URLSearchParams): string {
  const qs = new URLSearchParams();
  qs.set('withinDays', params.get('withinDays')?.trim() || '90');
  const vesselId = params.get('vesselId')?.trim();
  if (vesselId) qs.set('vesselId', vesselId);
  return `/crew/reports/coe-watchlist?${qs.toString()}`;
}

export function coeWatchlistBackPath(): string {
  return '/crew/coe-watchlist';
}

export function coeWatchlistTabLabel(tab: string | null | undefined): string | null {
  if (tab === 'coeSoon') return 'COE in window';
  if (tab === 'overdue') return 'Overdue intentions';
  return null;
}
